import { StyleFn } from '..'

export const Accordion: StyleFn = (theme) => {
  const { size } = theme

  return {
    root: {
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
    },
    actions: {
      marginBottom: size.spacing[16],
      textAlign: 'right',
    },
  }
}
